export const regions = [
  {
    id: 'af',
    name: 'africa',
    title: 'Africa',
    srs: 'EPSG:3857',
    bbox: [-2128992.2837949917, -4214602.3067408798, 5858710.218962431, 4615766.178543388],
    comments: 'basemap is in 3857 so bbox coords are in same format',
  },
  {
    id: 'camcar',
    name: 'camcar',
    title: 'Central America & Caribbean',
    srs: 'EPSG:3857',
    bbox: [-10562844, 484721, -7520843, 2654509],
    comments: 'basemap is in 3857 so bbox coords are in same format',
  },
  {
    id: 'global',
    name: 'global',
    title: 'Global',
    srs: 'EPSG:3857',
    bbox: [-18047246.778596736, -7248766.195662957, 20818785.99486994, 14376008.201786907],
    comments: 'basemap is in 3857 so bbox coords are in same format',
  },
];
